import { BrowserRouter, HashRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { IS_GITHUB_PAGES } from '@/env';
import { Routes } from '@/App';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import AuthProvider from '@/components/auth/AuthProvider';
import ThemeProvider from './Theme/Theme';

import '@/services/firebase';
import { ModalProvider } from '@ajorquera/libs/react';
import '@ajorquera/libs/react.css';

const Router = IS_GITHUB_PAGES ? HashRouter : BrowserRouter;

export default function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ThemeProvider>
        <SnackbarProvider>
          <AuthProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <ModalProvider>
                <Routes />
              </ModalProvider>
            </LocalizationProvider>
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </Router>
  );
}
